import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export function LegalAccept({ context }) {
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/legal/required", { params: { context } }).then(({ data }) => setDocs(data)).catch(() => setDocs([])); }, [context]);
  if (!docs.length) return null;
  return (
    <label className="flex items-start gap-2 text-sm" data-testid={`legal-accept-${context}`}>
      <input type="checkbox" required className="mt-1" data-testid={`legal-accept-checkbox-${context}`} />
      <span>Li e aceito {docs.map((d, i) => <span key={d.slug}>{i > 0 && (i === docs.length - 1 ? " e " : ", ")}<Link to={`/p/${d.slug}`} target="_blank" className="font-semibold text-bo-green underline">{d.title}</Link> (v{d.version})</span>)}.</span>
    </label>
  );
}
